import { Scenarios } from '@jfs/network'

const confirmFundTransfer = {
  default: [
    {
      url: /ats\/transaction/,
      method: 'POST',
      body: /"subType":0/,
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: {
          transactions: [
            {
              amount: '5000.00',
              grossAmount: '5060.00',
              charge: {
                value: 60.0,
                cgst: 4.58,
                igst: 0.0,
                sgst: 4.58,
                ugst: 0.0,
                serviceCharge: 50.84,
                tds: 0.0,
                tcs: 0.0,
              },
            },
            {
              amount: '5000.00',
              grossAmount: '5060.00',
              charge: {
                value: 60.0,
                cgst: 4.58,
                igst: 0.0,
                sgst: 4.58,
                ugst: 0.0,
                serviceCharge: 50.84,
                tds: 0.0,
                tcs: 0.0,
              },
            },
            {
              amount: '5000.00',
              grossAmount: '5060.00',
              charge: {
                value: 60.0,
                cgst: 4.58,
                igst: 0.0,
                sgst: 4.58,
                ugst: 0.0,
                serviceCharge: 50.84,
                tds: 0.0,
                tcs: 0.0,
              },
            },
            {
              amount: '5000.00',
              grossAmount: '5060.00',
              charge: {
                value: 60.0,
                cgst: 4.58,
                igst: 0.0,
                sgst: 4.58,
                ugst: 0.0,
                serviceCharge: 50.84,
                tds: 0.0,
                tcs: 0.0,
              },
            },
            {
              amount: '2000.00',
              grossAmount: '2024.00',
              charge: {
                value: 24.0,
                cgst: 1.83,
                igst: 0.0,
                sgst: 1.83,
                ugst: 0.0,
                serviceCharge: 20.34,
                tds: 0.0,
                tcs: 0.0,
              },
            },
          ],
        },
      },
      delay: 500,
    },
    {
      url: /ats\/transaction/,
      method: 'POST',
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: {
          rrn: '367635581530',
          transactionId: '10672234363558153000',
          originalId: '10012234363562032000',
          idempotentKey: '1607062703409160_1',
          transactionNetAmount: 121.0,
          transactionGrossAmount: 122.0,
          transactionTime: 'Fri Dec 09 17:39:22 IST 2022',
          remitterMobile: '9718295765',
          beneficiaryName: 'Mchf Kgjgjf',
          beneficiaryAccountNumber: '123456789',
          beneficiaryBankName: 'HDFC0000077',
          transactions: [
            {
              transactionId: '10012424359119646000',
              rrn: '424316251453',
              amount: 5000.0,
              charges: 60.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'SUCCESS',
            },
            {
              transactionId: '10012424359131380000',
              rrn: '424316253447',
              amount: 5000.0,
              charges: 60.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'PENDING',
            },
            {
              transactionId: '10012424359146420000',
              rrn: '424316256382',
              amount: 5000.0,
              charges: 60.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'FAILED',
              error: {
                code: 'errorCode',
                message: 'errorMessage',
              },
            },
            {
              transactionId: '10012424359153820000',
              rrn: '424316257276',
              amount: 3.0,
              charges: 1.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'SUCCESS',
            },
          ],
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /ats\/transaction/,
      method: 'POST',
      responseCode: 500,
      response: { status: 'FAILURE', error: { code: '33607', message: 'Invalid Entry of data.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { confirmFundTransfer }
